export const textStatusComercial = (lang, conciliacaos) => {

    let comercial = '0';
    let fiscal = '0';

    try{

        conciliacaos = conciliacaos.sort((a, b) => b.id - a.id)

        if(conciliacaos[0] !== undefined) {
            comercial = conciliacaos[0].statusConciliacaoComercial.id
            fiscal = conciliacaos[0].statusConciliacaoFiscal.id
        }
    } catch {}

    return [comercial, fiscal]
} 

export default textStatusComercial;